<script setup lang="ts">
import SitemapSection from "~/components/Pages/Sitemap/Section.vue"
import { SectionProps } from "./Section.props"

defineProps<SectionProps>()
</script>

<template>
  <ul>
    <li v-for="link in links" :key="link.label">
      <UtilsButton
        class="[&>span]:justify-start [&>span]:whitespace-normal"
        :to="link.path"
        :text="link.label"
        :theme="link.path ? 'ghost-green' : 'ghost-black'"
      >
        <template #icon
          ><UtilsIcon
            name="ChevronRight.svg"
            color="green-main"
            class="h-5 w-5"
        /></template>
      </UtilsButton>
      <div v-if="link && link.links" class="ml-4">
        <SitemapSection :links="link.links" />
      </div>
    </li>
  </ul>
</template>
